export { default } from "./VideoThumbnailWrapper.jsx";
